"use client";
import React from "react";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/routing";
import LocaleSwitcher from "../localization/locale-switcher";

export default function TopBanner() {
  const t = useTranslations();

  const [isTopBarVisible, setIsTopBarVisible] = React.useState(true);
  const [lastScrollY, setLastScrollY] = React.useState(0);

  React.useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 500) {
        // scrolling down & beyond threshold
        setIsTopBarVisible(false);
      } else if (currentScrollY < lastScrollY) {
        // scrolling up
        setIsTopBarVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <div
      className={`hidden bg-muted transition-all duration-300 ease-in-out lg:block ${
        isTopBarVisible ? "h-10 opacity-100" : "h-0 overflow-hidden opacity-0"
      }`}
    >
      <div className="container mx-auto h-full px-4 sm:px-6 md:px-8">
        <div className="flex h-full items-center justify-between text-sm">
          <div className="ellipsis shrink-1 mr-4 truncate text-ellipsis whitespace-nowrap">
            {/* <Button variant="link" className="px-0 text-foreground">
              <span className="ellipsis">{t("banner.announcement")}</span>
              <ArrowRightIcon />
            </Button> */}
            <span className="block max-w-full overflow-hidden truncate text-ellipsis whitespace-nowrap">
              {t("banner.announcement")}
            </span>{" "}
          </div>
          <div className="flex shrink-0 items-center space-x-6">
            <Link href="mailto:help@thunderproxy.com" className="hover:text-primary">
              help@thunderproxy.com
            </Link>
            <div className="flex items-center">
              <LocaleSwitcher />
            </div>
            <Link
              href={"https://dashboard.thunderproxy.com/auth/register"}
              className="shrink-0 whitespace-nowrap hover:text-primary"
            >
              {t("banner.actions.try_now.label")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
